export default "__VITE_ASSET__9957477d__"